import { AutoArrange } from './auto-arrange/auto-arrange'

export default {
	install(editor, { margin = { x: 50, y: 50 }, depth = null, vertical = false }) {
		editor.bind('arrange')
		
		const ar = new AutoArrange(editor, margin, depth, vertical)
		editor.on('arrange', ({ node }) => ar.arrange(node))
	}
}